import React from 'react';
import {View} from 'react-native';
import styles from './Spacer.style';

export default function Spacer(props) {
  const {containerStyle} = props;

  return <View style={[styles.container, containerStyle]} />;
}
